import { default as SocketClient } from './socketClient'

import config from '../config'

const publicSocket = new SocketClient({ host: config.app.url, path: config.socket.public.path })
const secureSocket = new SocketClient({ host: config.app.url, path: config.socket.secure.path, reconnect: false, delayConnect: true })

export { secureSocket, publicSocket }
